import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ControlsOf, FormControl, FormGroup } from '@ngneat/reactive-forms';
import { User } from 'src/app/classes/user.class';
import { Address, isAddress, LocationService } from 'src/app/services/location.service';
import { environment } from '../../../../../environments/environment';
import { FormGroupUserPlanning } from '../planning-detail-employees.component';

@Component({
    selector: 'app-address-dialog',
    templateUrl: './address-dialog.component.html',
    styleUrls: ['./address-dialog.component.scss'],
    standalone: false,
})
export class AddressDialogComponent implements OnInit {
    SelectedField = SelectedField;
    selectedField = SelectedField.work;
    user: User;
    location: string | null | undefined;
    controls: FormGroup<ControlsOf<FormGroupUserPlanning>>;

    form = new FormGroup<
        ControlsOf<{
            origin: string;
            destination: string;
            work_begin: string;
            work_end: string;
        }>
    >({
        origin: new FormControl(),
        destination: new FormControl(),
        work_begin: new FormControl(),
        work_end: new FormControl(),
    });
    to = false;

    companyAddress = environment.companyAddress;
    isAddress = isAddress;

    // Trackline: backend zet origin altijd op bedrijfsadres, tenzij aansluitend op vorig planning item
    get originFromPreviousWork(): boolean {
        const origin = this.form.value.origin;

        return (
            environment.platform === 'trackline' &&
            !!origin &&
            origin === this.controls.value.origin &&
            origin !== this.locationService.formatAddress(this.companyAddress)
        );
    }

    addresses: string[];

    search: FormControl<string> = new FormControl();

    constructor(
        public dialogRef: MatDialogRef<AddressDialogComponent>,

        @Inject(MAT_DIALOG_DATA)
        data: {
            control: FormGroup<ControlsOf<FormGroupUserPlanning>>;
            user: User;
            location: string;
        },

        private locationService: LocationService
    ) {
        this.controls = data.control;
        this.user = data.user;
        this.location = data.location;

        this.form.controls.origin.setValue(this.controls.value.origin);

        const userAddress = {
            street: this.user.street,
            housenumber: this.user.housenumber,
            zipcode: this.user.zipcode,
            town: this.user.town,
        };

        if (!this.form.value.origin) {
            this.choose(userAddress, SelectedField.origin);
        }

        this.form.controls.destination.setValue(this.controls.value.destination);

        // Bestaande planning: lege bestemming = aansluitend op volgende planning
        if (!this.form.value.destination && !this.controls.value.id) {
            this.choose(userAddress, SelectedField.destination);
        }

        this.form.controls.work_begin.setValue(this.controls.value.work_begin);

        if (!this.form.value.work_begin) {
            this.choose(this.location, SelectedField.work_begin);
        }

        this.form.controls.work_end.setValue(this.controls.value.work_end);

        if (!this.form.value.work_end) {
            this.choose(this.location, SelectedField.work_end);
        }
    }

    ngOnInit() {
        this.locationService
            .searchLocations(this.search.valueChanges, 'AddressDialogComponent.ngOnInit')
            .subscribe(result => {
                this.addresses = result.map(address => address.formattedAddress);
            });
    }

    save() {
        this.controls.get(SelectedField.origin).setValue(this.form.get(SelectedField.origin).value);
        this.controls.get(SelectedField.destination).setValue(this.form.get(SelectedField.destination).value);
        this.controls.get(SelectedField.work_begin).setValue(this.form.get(SelectedField.work_begin).value);
        this.controls.get(SelectedField.work_end).setValue(this.form.get(SelectedField.work_end).value);

        this.dialogRef.close();
    }

    choose(address: Partial<Address> | string, selectedField?: SelectedField) {
        if (!selectedField) {
            selectedField = this.selectedField;
        }

        address = isAddress(address) ? this.locationService.formatAddress(address) : (address as string);

        if (selectedField === SelectedField.work) {
            this.form.get(SelectedField.work_end).setValue(address);
            this.form.get(SelectedField.work_begin).setValue(address);
        } else {
            this.form.get(selectedField).setValue(address);
        }
    }

    close() {
        this.dialogRef.close();
    }
}

enum SelectedField {
    origin = 'origin',
    destination = 'destination',
    work_begin = 'work_begin',
    work_end = 'work_end',
    work = 'work',
}
